import React from "react";
// import "./viewSub.css";
import CustomModal from "../../../../components/Modal/CustomModal";

const ViewSub = ({ viewData }) => {
  const renderValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return "N/A";
    }
    return value;
  };

  return (
    <div className="view-details-container px-1 ">
      <div className="row mb-3">
        <div className="form-group col-sm-6 view-col mb-0">
          {/* <div className="detail-group">
            <span>MSISDN</span>
            <span className="colon">:</span>
            <span className="value">{renderValue(viewData?.msisdn)}</span>
          </div> */}
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>MSISDN</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.msisdn)}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          {/* <div className="detail-group">
            <label>Service Name</label>
            <span className="colon">:</span>
            <span className="value">{renderValue(viewData?.serviceName)}</span>
          </div> */}
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Service Name</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.serviceName)}</div>
          </div>
        </div>
        {/* </div> */}

        {/* <div className="row mb-3"> */}
        <div className="form-group col-sm-6 view-col mb-0">
          {/* <div className="detail-group">
            <label>Product ID</label>
            <span className="colon">:</span>
            <span className="value">{renderValue(viewData?.productId)}</span>
          </div> */}
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Product ID</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.productId)}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Service ID</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.serviceId)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.serviceId)}</div>
          </div>
        </div>
        {/* </div> */}

        {/* <div className="row mb-4"> */}
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Subscription ID</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.subscriptionId)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.subscriptionId)}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Subscription Date</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.subscriptionDateTime)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.subscriptionDateTime)}</div>
          </div>
        </div>
        {/* </div> */}

        {/* <div className="row mb-4"> */}
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Operator Code</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.operatorCode)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.operatorCode)}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Is Prepaid</span><span>:</span></div>
            {/* <span className="value">{viewData?.isPrepaid === "0" ? "No" : "Yes"}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.isPrepaid === "0" ? "No" : "Yes"}</div>
          </div>
        </div>
        {/* </div> */}

        {/* <div className="row mb-4"> */}
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Refund Status</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.refundStatus)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.refundStatus)}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Number of Attempts</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.noOfAttempt)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.noOfAttempt)}</div>
          </div>
        </div>
        {/* </div> */}

        {/* <div className="row mb-4"> */}
        <div className="form-group col-sm-6 view-co mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Next Billed Date</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.nextBilledDate)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.nextBilledDate)}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Process Date Time</span><span>:</span></div>
            {/* <span className="value">{renderValue(viewData?.processDateTime)}</span> */}
            <div className="col-sm-6 fw-bold text-wrap cont_div">{renderValue(viewData?.processDateTime)}</div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default ViewSub;
